
export const calculateJobSalary = (assetTable, effectiveDate, baseOnly, salaryType) => {
 
      var monthlySalary = 0;
      if (!baseOnly){
          baseOnly = false;
      }
      if (!salaryType){
          salaryType = "monthly";
      }
      // determine current monthly salary
      for (let i=0; i< assetTable.length; i++){
          if (+assetTable[i].assetNbrMonths === -1 &&
               assetTable[i].assetStartDate <= effectiveDate){
                  if ((baseOnly === false) || 
                        (baseOnly === true && assetTable[i].assetItem === "Job Salary")) {
                              monthlySalary += +assetTable[i].assetAmt;
                        }
                  }
      }
      let returnSalary = monthlySalary;
      if (salaryType === "annual"){
            returnSalary = (monthlySalary * 12).toFixed(2);
      }
            
      return returnSalary;
   
}

export default calculateJobSalary;
